/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useEffect, useState } from 'react';

import { KeyboardKeys } from '../../core';

export const useCapsLockDetector = (): boolean => {
    const [capsLockState, setCapsLockState] = useState(false);

    useEffect(() => {
        function capsLockKeyEventHandler(e: KeyboardEvent) {
            const isActive = e.getModifierState?.(KeyboardKeys.CapsLock);

            if (isActive !== capsLockState) {
                setCapsLockState(isActive);
            }
        }

        document.addEventListener('keydown', capsLockKeyEventHandler);
        document.addEventListener('keyup', capsLockKeyEventHandler);

        return () => {
            document.removeEventListener('keydown', capsLockKeyEventHandler);
            document.removeEventListener('keyup', capsLockKeyEventHandler);
        };
    });

    return capsLockState;
};
